import { EventObject } from 'xstate-v4'

/**
 *
 * @see https://github.com/davidkpiano/xstate-v4/discussions/1591
 */
export function assertEventType<
  TE extends EventObject,
  TType extends TE['type'],
>(event: TE, eventType: TType): asserts event is TE & { type: TType } {
  if (event.type !== eventType) {
    throw new Error(
      `Invalid event: expected "${eventType}", got "${event.type}"`,
    )
  }
}
